<template>
  <div class="export-menu">
    <button class="export-btn" @click="toggleOpen" :disabled="disabled">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" width="16" height="16">
        <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
      </svg>
      Export
    </button>
    <div v-if="isOpen" class="export-dropdown">
      <button v-for="format in formats" :key="format.key" class="export-option" @click="doExport(format.key)">
        {{ format.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExportMenu',
  props: {
    formats: { type: Array, default: function() { return [{ key: 'csv', label: 'CSV' }]; } },
    disabled: { type: Boolean, default: false }
  },
  data: function() {
    return { isOpen: false };
  },
  methods: {
    toggleOpen: function() { this.isOpen = !this.isOpen; },
    doExport: function(format) {
      this.$emit('export', format);
      this.isOpen = false;
    }
  }
};
</script>

<style scoped>
.export-menu {
  position: relative;
}

.export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  color: #475569;
  border: 1px solid #cbd5e1;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Inter', sans-serif;
}
.export-btn:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }
.export-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.export-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 100;
  min-width: 140px;
}

.export-option {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 16px;
  background: none;
  border: none;
  font-size: 0.8125rem;
  color: #334155;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  transition: background 0.1s;
}
.export-option:hover { background: #f1f5f9; }
.export-option:first-child { border-radius: 6px 6px 0 0; }
.export-option:last-child { border-radius: 0 0 6px 6px; }
</style>
